/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentRoleEnabledRequest
 */
export interface ParentRoleEnabledRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ParentRoleEnabledRequest
     */
    parentRoleIds: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ParentRoleEnabledRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the ParentRoleEnabledRequest interface.
 */
export function instanceOfParentRoleEnabledRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parentRoleIds" in value;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function ParentRoleEnabledRequestFromJSON(json: any): ParentRoleEnabledRequest {
    return ParentRoleEnabledRequestFromJSONTyped(json, false);
}

export function ParentRoleEnabledRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRoleEnabledRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentRoleIds': json['parentRoleIds'],
        'enabled': json['enabled'],
    };
}

export function ParentRoleEnabledRequestToJSON(value?: ParentRoleEnabledRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentRoleIds': value.parentRoleIds,
        'enabled': value.enabled,
    };
}

